export default "__VITE_ASSET__CWohmnj$__"